import React from 'react';

import { MOBILE_BREAK_POINT } from 'app/constants';
import useIsMobile from 'hooks/use-is-mobile';
import { Period } from 'pages/Landings/sections/Pricing/types';

import Desktop from './variants/Desktop';
import Mobile from './variants/Mobile';

interface Props {
    period: Period;
    className?: string;
}

const Plans: React.FC<Props> = ({ period, className }) => {
    const isMobile = useIsMobile(MOBILE_BREAK_POINT);
    return isMobile ? (
        <Mobile period={period} className={className} />
    ) : (
        <Desktop period={period} className={className} />
    );
};

export default Plans;
